import addRow from './add-row'
import deleteRow from './delete-row'

window.addEventListener('load', () => {
	const rows = document.querySelectorAll('.add-row')

	if (!rows) {
		return
	}

	rows.forEach(row => {
		row.addEventListener('click', addRow)
	})
})

window.addEventListener('load', () => {
	const rows = document.querySelectorAll('.delete-row')

	if (!rows) {
		return
	}

	rows.forEach(row => {
		row.addEventListener('click', deleteRow)
	})
})
